<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="getContactos"
      :search="search"
    >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title> <h3>{{title}}</h3> </v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="teal" dark class="mb-2" v-bind="attrs" v-on="on">
               <v-icon>mdi-notebook-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{formTitle}}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="editedItem.tipo" hint="Teléfono Tigo" color="teal" label="Tipo"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="editedItem.valor" hint="+502 5525-6682" color="teal" label="Valor"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red"
                dark
                @click="close"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="teal"
                dark
                @click="save"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
     <template v-slot:[`item.opciones`]="{ item }">
      <v-btn icon color="blue" @click="editItem(item)">
        <v-icon>mdi-lead-pencil</v-icon>
      </v-btn>
      <v-btn icon color="red" @click="deleteSwal(item)">
        <v-icon>mdi-trash-can</v-icon>
      </v-btn>
    </template>
    </v-data-table>
  </v-card>
</template>
<script>
import Swal from 'sweetalert2'

export default {
    data: () => ({
        dialog:false,
        search:'',
        title:'CONTACTO',
        headers:[
            { text: 'Tipo', value: 'tipo' },
            { text: 'Valor', value: 'valor' },
            { text: 'Opciones', value: 'opciones' }
        ],
        editedIndex: -1,
        editedItem: {
            tipo:'',
            valor:''
        },
        defaultItem: {
            tipo:'',
            valor:''
        }
    }),
  created(){
      const id = parseInt(  localStorage.getItem('idpersona') ) 
      this.$store.dispatch("setIdPersona",id)
      this.$store.dispatch("getContactos")
  }, 
    computed:{
        getContactos(){
        return this.$store.getters.getContactos;
        },
        formTitle() {
            return this.editedIndex === -1 ? 'Nuevo Registro' : 'Editar Registro';
        },
    },
    methods:{
      async getItems(){
            await this.$store.dispatch("getContactos");
      },
      async postItem(){
        
        await  this.$store.dispatch("postContacto",this.editedItem);
      },
      async putItem(){
          await this.$store.dispatch("putContacto",this.editedItem);
      },
      editItem(item) {   
          this.dialog = true; 
          this.editedIndex = this.getContactos.indexOf(item)       
          this.editedItem = Object.assign({}, item)
      },
      async deleteItem(id){
          await this.$store.dispatch("deleteContacto",id);
      },
     save () {

          if (this.editedIndex > -1) {
                this.putItem();
          } else {
               this.postItem(); 
          }
          this.close()
     },
     async close(){  
         this.dialog = false;
         this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1
          })
     },
     deleteSwal(item){
        Swal.fire({
        title: 'Presione Sí para eliminar',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText:'Cancelar',
        confirmButtonText: 'Sí'
        }).then((result) => {
        if (result.isConfirmed) {
            this.deleteItem(item.idcontacto);
        }
        })
    },
  }
}
</script>